import { BrowseProductEntitlementResponse } from '@aibees/shared/definition';
import { useBaseQuery } from '@aibees/shared/http/hooks';
import { useCustomerEndpoint } from '@aibees/shared/workspace';

export function useBrowseProductEntitlementApi() {
  const url = useCustomerEndpoint('entitlement');

  return useBaseQuery<never, BrowseProductEntitlementResponse>(
    [useBrowseProductEntitlementApi.name],
    {
      url,
      params: {
        return: 'features',
      },
    }
  );
}
